import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-25 10:29:18
 * @LastEditTime: 2022-02-27 22:37:49
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { createContext, useContext } from 'react';
import _ from 'lodash';
export const ModuleContext = /*#__PURE__*/createContext({});
export const useCurrentModule = () => {
  return useContext(ModuleContext);
};

const BaseModule = props => {
  const {
    Render: RD,
    id,
    moduleUid,
    children,
    label
  } = props;
  if (!children || children.length === 0) return null;

  if (moduleUid) {
    return /*#__PURE__*/React.createElement(ModuleContext.Provider, {
      value: _objectSpread(_objectSpread({}, props), {}, {
        buttonCode: id
      })
    }, /*#__PURE__*/React.createElement("div", {
      id: id
    }, /*#__PURE__*/React.createElement(RD, {
      components: children
    })));
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    name: label
  }, /*#__PURE__*/React.createElement(RD, {
    components: children
  }));
};

export default BaseModule;